import runtimeConfig from '../config'

const isFullScreenMode = () => {
  console.log(runtimeConfig)
  return runtimeConfig.site === 'susieau'
}

export default isFullScreenMode
